var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8847 22.2985C29.7762 24.19 29.5735 27.3852 27.2752 28.9967C25.8124 30.0219 23.7708 30.0219 22.3081 28.9967C20.0097 27.3838 19.8056 24.19 21.6985 22.2985C23.4062 20.5894 26.177 20.5894 27.8847 22.2985",
    stroke: "url(#paint0_linear_760_44903)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8848 28.4848L30.625 31.225",
    stroke: "url(#paint1_linear_760_44903)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 15.1833H7.29167C5.68021 15.1833 4.375 13.8781 4.375 12.2667V7.89167C4.375 6.28021 5.68021 4.97501 7.29167 4.97501H11.6667C13.2781 4.97501 14.5833 6.28021 14.5833 7.89167V12.2667C14.5833 13.8781 13.2781 15.1833 11.6667 15.1833Z",
    stroke: "url(#paint2_linear_760_44903)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7084 15.1833H23.3334C21.722 15.1833 20.4167 13.8781 20.4167 12.2667V7.89167C20.4167 6.28021 21.722 4.97501 23.3334 4.97501H27.7084C29.3199 4.97501 30.6251 6.28021 30.6251 7.89167V12.2667C30.6251 13.8781 29.3199 15.1833 27.7084 15.1833Z",
    stroke: "url(#paint3_linear_760_44903)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 31.225H7.29167C5.68021 31.225 4.375 29.9198 4.375 28.3083V23.9333C4.375 22.3219 5.68021 21.0167 7.29167 21.0167H11.6667C13.2781 21.0167 14.5833 22.3219 14.5833 23.9333V28.3083C14.5833 29.9198 13.2781 31.225 11.6667 31.225Z",
    stroke: "url(#paint4_linear_760_44903)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_760_44903",
    x1: 22.3853,
    y1: 21.0167,
    x2: 27.7906,
    y2: 21.6882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4904D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_760_44903",
    x1: 28.5013,
    y1: 28.4848,
    x2: 30.1943,
    y2: 28.6951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4904D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_760_44903",
    x1: 6.67188,
    y1: 4.975,
    x2: 12.9787,
    y2: 5.75847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4904D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_760_44903",
    x1: 22.7136,
    y1: 4.975,
    x2: 29.0205,
    y2: 5.75847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4904D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_760_44903",
    x1: 6.67188,
    y1: 21.0167,
    x2: 12.9787,
    y2: 21.8001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4904D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionIcon);
export default __webpack_public_path__ + "static/media/collection-icon.60618a3bb5ad4da489a480fe48125fd7.svg";
export { ForwardRef as ReactComponent };